import React from "react";
import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const socials = [
  { id: 1, icon: <FaGithub />, link: "https://github.com/SlickAF31", label: "GitHub" },
  {
    id: 2,
    icon: <FaLinkedinIn />,
    link: "https://www.linkedin.com/in/raul-cheveresan-9a21bb20b/",
    label: "LinkedIn",
  },
];

const Sidebar = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-surface border-b border-border">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-3 flex flex-wrap items-center justify-between gap-3">
        <p className="font-mono text-xs text-muted">
          {t("sidebar.position")} <span className="text-text">{t("sidebar.company")}</span>
        </p>
        <ul className="flex items-center gap-2">
          {socials.map((social) => (
            <SocialIcon social={social} key={social.id} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;

const SocialIcon = (props) => {
  const { icon, link, label } = props.social;
  return (
    <li>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className="w-11 h-11 flex items-center justify-center rounded border border-border text-muted hover:text-cyan hover:border-cyan transition"
      >
        {icon}
      </a>
    </li>
  );
};
